<template>
    <div>
      <el-card>
        <h2>余额宝记录</h2>
  
        <el-table :data="recordList" border style="width: 100%; max-height: 600px; overflow-y: auto;">
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column label="用户信息">
            <template #default="{ row }">
              <div>账号：{{ row.user.account }}</div>
              <div>用户名：{{ row.user.username }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="记录类型">
            <template #default="{ row }">
              <el-tag :type="row.type === 'deposit' ? 'success' : row.type === 'withdraw' ? 'danger' : 'warning'">
                {{ row.type === 'deposit' ? '存入' : row.type === 'withdraw' ? '取出' : '利息' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="金额" />
          <el-table-column prop="balance" label="操作后余额" />
          <el-table-column prop="remark" label="备注" />
          <el-table-column prop="created_at" label="操作时间" />
        </el-table>
  
        <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.limit"
          :total="total"
          @current-change="handlePageChange"
        />
      </el-card>
    </div>
  </template>
  
  <script>
  import { getYuebaorecord } from '@/api/yuebaorecord';
  
  export default {
    name: 'YuebaoRecord',
    data() {
      return {
        recordList: [],
        pagination: {
          page: 1,
          limit: 20
        },
        total: 0
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      async fetchData() {
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit
        };
        const { data } = await getYuebaorecord(params);
        this.recordList = data.items.map(item => ({
          ...item,
          user: item.user || { account: '', username: '' }
        }));
        this.total = data.total;
      },
      handlePageChange(page) {
        this.pagination.page = page;
        this.fetchData();
      }
    }
  };
  </script>
  
  <style scoped>
  .el-card {
    margin: 20px;
  }
  
  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
  </style>